export default __webpack_public_path__ + "static/media/forgotPassword.62527299.svg";